export default __webpack_public_path__ + "static/homepage-bac5c72d06b8f9245ad774b80b366489.webm";